import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  captions: {
    color: 'white',
    justifyContent: 'flex-start',
    width: '100%',
    padding: '0 24px',
    position: 'absolute',
    top: -60,
    left: 0,
    '&$popoutMode': {
      display: 'none'
    }
  },

  popoutMode: {},

  mobile: {
    position: 'absolute',
    left: 0,
    top: -70
  },

  captionText: {
    textAlign: 'left',
    background: '#000',
    fontSize: '1.25em',
    fontFamily: 'Roboto',
    fontWeight: '400',
    padding: '0 10px',
    textTransform: 'uppercase',
    maxWidth: '40%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    marginBottom: 0,
    display: '-webkit-box',
    boxOrient: 'vertical',
    lineClamp: 2,
    wordBreak: 'break-all'
  },
  captionTextMobile: {
    maxWidth: '100%',
    fontSize: 14,
    lineHeight: '1.8em'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/ClosedCaptions/styles.js